"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.replaceFromString = void 0;
/**
 * Returns new string after replacing all the matching patterns.
 *
 * @param {string} value string which needs a replacement.
 * @param {array} patterns array of patterns to be replaced.
 * @param {string} replaceWith string with which patterns needs to be replaced.
 */
var replaceFromString = function (value, patterns, replaceWith) {
    var regexpattern = __spreadArray([], patterns, true).reduce(function (pattern, current) { return "".concat(pattern, "|").concat(current); }, '')
        .replace(/\|/, '');
    var regex = new RegExp(regexpattern, 'gi');
    return value === null || value === void 0 ? void 0 : value.replace(regex, replaceWith);
};
exports.replaceFromString = replaceFromString;
